import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-books-hero-yellow-sweater.jpg`;
const ALT = "Lara at her desk in a yellow sweater, editing pages by hand beside a stack of her four books, a candle and fresh lilacs.";

export function BooksHero() {
  return (
    <section data-testid="books-hero" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-[49px] lg:pb-[49px]">
        {/* Desktop image half-band, right side, bleeds to outer/top/bottom edge */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[58%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-hero-image"
            bg="#FAFAF8"
            objectPosition="32% 32%"
            featherLeft={40}
            featherTop={9}
            featherBottom={9}
            fadeOpacity={0.75}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mt-6">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-hero-image-mobile"
            bg="#FAFAF8"
            objectPosition="40% 28%"
            featherBottom={19}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-10 lg:pt-0 flex items-center lg:min-h-[538px]">
          <div className="w-full lg:w-[52%] lg:-translate-y-[2%]">
            <div className="max-w-[468px]">
              <p className="text-xs tracking-[0.22em] uppercase text-[#159E9A] mb-5">
                The Books
              </p>
              <h1
                data-testid="books-hero-headline"
                className="font-display text-[36px] sm:text-[48px] lg:text-[56px] leading-[1.1] tracking-tight text-[#1C1917]"
              >
                Some stories stay with you until you write them down.
              </h1>
              <p className="mt-[48px] mb-[24px] text-[19px] md:text-[21px] leading-relaxed text-[#57534E]">
                Every book on this page started the same way. A question I
                couldn&rsquo;t stop thinking about. A story that refused to
                leave. A quiet moment that asked me to pay attention. Some
                became books. Others are still scattered across my floor
                waiting to become whatever they&rsquo;re meant to be.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
